import API from "@/axios";
import { RootState } from "@/store/types";
import { ActionTree } from "vuex";
import { CompanyInformationState, CompanyInformationPayload } from "../types";

const actions: ActionTree<CompanyInformationState, RootState> = {
  async updateBillingInfo({ dispatch }, payload: CompanyInformationPayload) {
    const {
      zipcode,
      city,
      addressLine1,
      addressLine2,
      websiteUrl,
      country,
      billingContactName,
      billingContactEmail,
      name,
    } = payload;
    return API.post("/settings/billing_info", {
      zipOrPostalCode: zipcode,
      city,
      addressLine1,
      addressLine2,
      websiteUrl,
      billingContactName,
      billingContactEmail,
      name,
      isO2Country: country,
    }).then(async () => {
      dispatch("setZipcode", zipcode);
      dispatch("setCity", city);
      dispatch("setAddressLine1", addressLine1);
      dispatch("setAddressLine2", addressLine2);
      dispatch("setWebsiteUrl", websiteUrl);
      dispatch("setCountry", country);
      dispatch("setBillingContactName", billingContactName);
      dispatch("setBillingContactEmail", billingContactEmail);
      dispatch("setName", name);
    });
  },
  setZipcode({ commit }, zipcode) {
    commit("setZipcode", zipcode);
  },
  setCity({ commit }, city) {
    commit("setCity", city);
  },
  setAddressLine1({ commit }, addressLine1) {
    commit("setAddressLine1", addressLine1);
  },
  setAddressLine2({ commit }, addressLine2) {
    commit("setAddressLine2", addressLine2);
  },
  setWebsiteUrl({ commit }, websiteUrl) {
    commit("setWebsiteUrl", websiteUrl);
  },
  setCountry({ commit }, country) {
    commit("setCountry", country);
  },
  setBillingContactName({ commit }, billingContactName) {
    commit("setBillingContactName", billingContactName);
  },
  setBillingContactEmail({ commit }, billingContactEmail) {
    commit("setBillingContactEmail", billingContactEmail);
  },
  setName({ commit }, name) {
    commit("setName", name);
  },
};

export default actions;
